"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SelectWithNewEntry_1 = __importDefault(require("components/common/inputs/SelectWithNewEntry"));
var close_icon_svg_1 = __importDefault(require("res/img/close-icon.svg"));
var AddButton_1 = __importDefault(require("../../../common/buttons/AddButton"));
var EditProductSpecsItem = function (_a) {
    var productSpec = _a.productSpec, storeSpec = _a.storeSpec, onRemoveSpec = _a.onRemoveSpec, onAddSpecItem = _a.onAddSpecItem, onRemoveSpecItem = _a.onRemoveSpecItem, onSubmitSpecItem = _a.onSubmitSpecItem;
    var _b = react_1.useState(false), open = _b[0], setOpen = _b[1];
    var toggleOpen = function () {
        setOpen(!open);
    };
    var addItemHandler = function (item) {
        setOpen(false);
        onAddSpecItem(item);
    };
    var submitItemHandler = function (value) {
        if (value.length > 0) {
            setOpen(false);
            onSubmitSpecItem(value);
        }
    };
    var getOptions = function () {
        if (!productSpec.productSpecificationItems) {
            return storeSpec.productSpecificationItems;
        }
        return storeSpec.productSpecificationItems.map(function (option) {
            for (var _i = 0, _a = productSpec.productSpecificationItems; _i < _a.length; _i++) {
                var dataOption = _a[_i];
                if (option.id === dataOption.id) {
                    return __assign(__assign({}, option), { live: false });
                }
            }
            return option;
        });
    };
    return (react_1.default.createElement("div", { className: 'edit-product__tag-item' },
        react_1.default.createElement("div", { className: 'flex flex-row' },
            react_1.default.createElement("span", { className: 'edit-product__tag-item__label' },
                productSpec.name,
                ":"),
            react_1.default.createElement("div", { className: 'edit-product__tag-item__options flex flex-row' },
                productSpec.productSpecificationItems &&
                    productSpec.productSpecificationItems.map(function (item) { return (react_1.default.createElement("div", { className: 'edit-product__tag-item__option flex flex-row', key: item.id },
                        react_1.default.createElement("span", null, item.name),
                        react_1.default.createElement("button", { type: 'button', "aria-label": 'Remove', onClick: function () { return onRemoveSpecItem(item); }, className: 'flex flex-column flex-center', title: 'Remove' },
                            react_1.default.createElement("img", { src: close_icon_svg_1.default, alt: 'Remove' })))); }),
                !open &&
                    react_1.default.createElement(AddButton_1.default, { label: "Add " + productSpec.name.toLowerCase(), onClick: toggleOpen })),
            react_1.default.createElement("button", { type: 'button', "aria-label": 'Remove', className: 'edit-product__tag-item__remove', onClick: onRemoveSpec, title: 'Remove' }, "Remove")),
        open &&
            react_1.default.createElement("div", { className: 'edit-product__tag-item__form form' },
                react_1.default.createElement("span", { className: 'title' },
                    "Add a ",
                    productSpec.name),
                react_1.default.createElement("button", { type: 'button', title: 'Close', "aria-label": 'close', className: 'edit-product__tag-item__form__close flex flex-column flex-center', onClick: toggleOpen },
                    react_1.default.createElement("img", { src: close_icon_svg_1.default, alt: 'Close' })),
                react_1.default.createElement(SelectWithNewEntry_1.default, { value: null, label: "" + productSpec.name, data: getOptions(), onChange: addItemHandler, onSubmit: submitItemHandler }))));
};
exports.default = EditProductSpecsItem;
